import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {Feature} from '../models';

@Injectable()
export class FeatureService extends IoService {
  protected model = Feature;
  protected listUrl = '/features/';
}
